module.exports = __webpack_public_path__ + "static/media/insight4.69bcceae.jpg";